import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ActiveWorkflowsDialogComponent } from '../../../shared/components/active-workflows-dialog/active-workflows-dialog.component';
import { MyQueueStatus } from '../../models/my-queue-status.model';
import { SignalrService } from '../../services/signalr.service';
import { UserService } from '../../services/user.service';
import { WorkflowRunQueueService } from '../../services/workflow-run-queue.service';

@Component({
    selector: 'ca-workflow-panel',
    templateUrl: './workflow-panel.component.html',
    styleUrls: ['./workflow-panel.component.scss'],
    providers: [SignalrService],
})
export class WorkflowPanelComponent implements OnInit {
    modalRef: NgbModalRef;
    hasRunningWorkflow$: Observable<boolean>;

    get pendingQueue(): MyQueueStatus[] {
        return this.workflowRunQueueService.activeWorkflows.filter(result => !result.executedAt);
    }

    get runningQueue(): MyQueueStatus[] {
        return this.workflowRunQueueService.activeWorkflows.filter(result => result.executedAt);
    }

    constructor(
        private modalService: NgbModal,
        private workflowRunQueueService: WorkflowRunQueueService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.hasRunningWorkflow$ = this.workflowRunQueueService.hasRunningWorkflow$.pipe(
            tap((hasRunningWorkflow: boolean) => {
                if (this.modalRef && !hasRunningWorkflow) {
                    this.modalRef.close();
                }
            }),
        );
    }

    openActiveWorkflowsDialog(): void {
        this.modalRef = this.modalService.open(ActiveWorkflowsDialogComponent, { size: 'lg' });
        this.modalRef.componentInstance.isAdminUser = this.userService.myInfo?.isAdmin;
        this.workflowRunQueueService.activeWorkflows$
            .pipe(
                map((activeWorkflows: MyQueueStatus[]) => {
                    try {
                        if (this.modalRef?.componentInstance) {
                            this.modalRef.componentInstance.activeWorkflows = activeWorkflows;
                        }
                    } catch (error) {
                        console.warn('WorkflowPanelComponent ', error);
                    }
                }),
            )
            .subscribe();
    }
}
